import { GetTypesForFilterActionTypes, GetTypesForFilterState, GET_TYPES_FOR_FILTER_FAILURE, GET_TYPES_FOR_FILTER_REQUEST, GET_TYPES_FOR_FILTER_SUCCESS } from './types';

const defaultState: GetTypesForFilterState = {
  isLoading: false,
  errorMessage: ''
};

export default function getTypesForFilter(state = defaultState, action: GetTypesForFilterActionTypes): GetTypesForFilterState {
  switch (action.type) {
    case GET_TYPES_FOR_FILTER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_TYPES_FOR_FILTER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ''
      };
    case GET_TYPES_FOR_FILTER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ''
      };
    default:
      return state;
  }
};